import { Icon, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import Button from '@mui/material/Button'
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined'

import { Box } from '@mui/material'
import SidebarItems from './SidebarItems'
import useAuth from '../../../hooks/useAuth'
import { useAppSelector } from 'hooks'
import { InfoOutlined } from '@mui/icons-material'
import { ContentCenteredWrapper, FlexWrapper } from 'assets/styles'
import { ExternalLinks } from 'models'

const Sidebar = ({ setModalOpen }: { setModalOpen: (value: boolean) => void }) => {
  const theme = useTheme()
  const sidebarOpen = useAppSelector((state) => state.sidebar.sidebarOpen)
  const handleClickNovaCopia = () => {
    setModalOpen(true)
  }

  const auth = useAuth()

  return (
    <Box
      style={{
        maxWidth: sidebarOpen ? '16rem' : '5rem',
        minWidth: sidebarOpen ? '16rem' : '5rem',
        transition: 'max-width 0.2s, min-width 0.2s linear',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflowY: 'auto',
        overflowX: 'hidden'
      }}>
      <ContentCenteredWrapper sx={{ flexDirection: 'column' }}>
        <Tooltip
          enterDelay={1000}
          enterNextDelay={1000}
          placement="right"
          title={sidebarOpen ? '' : 'Crea una còpia'}>
          <FlexWrapper sx={{ padding: '2rem 1rem', width: '100%', boxSizing: 'border-box' }}>
            <Button onClick={handleClickNovaCopia} variant="contained" sx={{ width: '100%' }}>
              <Icon component={CreateNewFolderOutlinedIcon} />
              {sidebarOpen && (
                <Typography
                  sx={{
                    color: theme.palette.primary.contrastText,
                    paddingLeft: '0.5rem',
                    whiteSpace: 'nowrap'
                  }}>
                  Crea una còpia
                </Typography>
              )}
            </Button>
          </FlexWrapper>
        </Tooltip>
        <SidebarItems isAdmin={auth.isAdmin} sidebarOpen={sidebarOpen} />
      </ContentCenteredWrapper>
      <ContentCenteredWrapper
        sx={{ flexDirection: 'column', alignItems: 'flex-start', padding: '2rem 1rem' }}>
        <IconButton onClick={() => window.open(ExternalLinks.firstStepsHelp, '_blank')}>
          <Icon component={InfoOutlined} />
        </IconButton>
      </ContentCenteredWrapper>
    </Box>
  )
}

export default Sidebar
